import React, { useMemo } from 'react';
import macroOverviewIcon from '@/imgs/MacroEnv/macro-overview-icon.png';
import economicGrowthIcon from '@/imgs/MacroEnv/economic-growth-icon.png';
import inflationIcon from '@/imgs/config-icon.png';
import monetaryPolicyIcon from '@/imgs/MacroEnv/monetary-policy-icon.png';
import marketSentimentIcon from '@/imgs/MacroEnv/market-sentiment-icon.png';
import { isCanParseJson, normalizeToJSON } from '@/lib/utils';
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
import useCopilotValueStore from '@/stores/copilotValueStore';
import { CopilotValue17Detail } from '@/stores/types/copilotDeatail/copilot17Detail';

interface MacroIndicator {
  icon: string;
  title: string;
  subtitle: string;
  tooltip: string;
}

interface MacroEnvProps {
  className?: string;
}

const MacroEnv: React.FC<MacroEnvProps> = ({ className = '' }) => {
  const { copilotValue17 } = useCopilotValueStore();

  const indicators: MacroIndicator[] = useMemo(() => {
    const list = [];

    const market_analysis = copilotValue17?.market_analysis || [];

    market_analysis?.forEach((item: CopilotValue17Detail) => {
      if (item.经济增长分析) {
        item.经济增长分析 = normalizeToJSON(item.经济增长分析);
        const obj = isCanParseJson(item.经济增长分析 || '')
          ? JSON.parse(item.经济增长分析 || '')
          : {};
        console.log(obj, item.经济增长分析, 'obj');
        list.push({
          icon: economicGrowthIcon,
          title: '经济增长',
          subtitle: obj.状态值 || '',
          tooltip: obj.详情 || ''
        });
      }
      if (item.通货膨胀分析) {
        item.通货膨胀分析 = normalizeToJSON(item.通货膨胀分析);
        const obj = isCanParseJson(item.通货膨胀分析 || '')
          ? JSON.parse(item.通货膨胀分析 || '')
          : {};
        console.log(obj, 'obj');
        list.push({
          icon: inflationIcon,
          title: '通货膨胀',
          subtitle: obj.状态值 || '',
          tooltip: obj.详情 || ''
        });
      }
      if (item.货币政策分析) {
        item.货币政策分析 = normalizeToJSON(item.货币政策分析);
        const obj = isCanParseJson(item.货币政策分析 || '')
          ? JSON.parse(item.货币政策分析 || '')
          : {};
        list.push({
          icon: monetaryPolicyIcon,
          title: '货币政策',
          subtitle: obj.状态值 || '',
          tooltip: obj.详情 || ''
        });
      }
      if (item.市场情绪分析) {
        item.市场情绪分析 = normalizeToJSON(item.市场情绪分析);
        const obj = isCanParseJson(item.市场情绪分析 || '')
          ? JSON.parse(item.市场情绪分析 || '')
          : {};
        list.push({
          icon: marketSentimentIcon,
          title: '市场情绪',
          subtitle: obj.状态值 || '',
          tooltip: obj.详情 || ''
        });
      }
    });
    return list;
  }, [copilotValue17]);

  return (
    <div className={`flex flex-col gap-3 ${className} mt-4 w-full`}>
      {/* 标题区域 */}
      <div className="flex items-center gap-1">
        <div className="h-6rounded flex w-6 items-center justify-center">
          <img src={macroOverviewIcon} alt="宏观环境" className="h-6 w-6 object-cover" />
        </div>
        <h3 className="text-base font-semibold text-black">宏观市场环境分析</h3>
      </div>

      {/* 指标卡片区域 */}
      <div className="flex justify-between gap-2.5 rounded-lg bg-white p-4">
        {indicators.map((indicator, index) => (
          <TooltipProvider key={index}>
            <Tooltip>
              <TooltipTrigger asChild>
                <div key={index} className="w-21 flex flex-col items-center justify-center gap-1">
                  {/* 图标容器 */}
                  <div className="flex h-6 w-6 items-center justify-center rounded bg-white">
                    <img
                      src={indicator.icon}
                      alt={indicator.title}
                      className="h-full w-full object-contain"
                    />
                  </div>

                  {/* 文字内容 */}
                  <div className="text-center">
                    <div className="text-sm font-normal leading-5 text-[#1F1F1F]">
                      {indicator.title}
                    </div>
                    <div className="text-sm font-normal leading-5 text-[#5959EB]">
                      {indicator.subtitle || '-'}
                    </div>
                  </div>
                </div>
              </TooltipTrigger>
              <TooltipContent className="bg-black text-white">
                <p className="max-w-xs">{indicator.tooltip || '-'}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ))}
      </div>
    </div>
  );
};

export default MacroEnv;
